import { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { company } from '@/config/company'
import { NAV_LINKS } from '@/config/nav'
import { getBoardUrl } from '@/utils/appBase'
import styles from './SiteHeader.module.css'

export function SiteHeader() {
  const [open, setOpen] = useState(false)

  return (
    <header className={styles.wrap}>
      <div className={styles.topBar}>
        <div className={`container ${styles.topInner}`}>
          <a href={`tel:${company.phoneTel}`}>{company.phone}</a>
          <a href={`mailto:${company.email}`}>{company.email}</a>
          <span className={styles.hours}>{company.workingHours}</span>
        </div>
      </div>

      <div className={styles.header}>
        <div className={`container ${styles.inner}`}>
          <Link to="/" className={styles.brand} onClick={() => setOpen(false)}>
            <img src={company.logo} alt={company.name} width={52} height={52} />
            <span className={styles.brandText}>
              <strong>{company.name}</strong>
              <small>{company.legalName}</small>
            </span>
          </Link>

          <span className={styles.classLabel}>{company.classLabel}</span>

          <button
            type="button"
            className={styles.menuBtn}
            aria-label={open ? 'Menüyü kapat' : 'Menüyü aç'}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            <span />
            <span />
            <span />
          </button>

          <nav className={`${styles.nav} ${open ? styles.navOpen : ''}`} aria-label="Ana menü">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === '/'}
                onClick={() => setOpen(false)}
                className={({ isActive }) => (isActive ? styles.active : undefined)}
              >
                {link.label}
              </NavLink>
            ))}
            <a className={styles.board} href={getBoardUrl()} onClick={() => setOpen(false)}>
              Canlı Pano
            </a>
          </nav>
        </div>
      </div>
    </header>
  )
}
